function init(containerId, containerUrl) {
  console.log('INIT');

  if (!containerId) {
    console.error('Empty tracking code for Piwik Pro.');
    return;
  }

  if (!containerUrl) {
    console.error('Empty tracking URL for Piwik Pro.');
    return;
  }

  if (!document) {
    console.error('Was not possible to access Document interface. Make sure this module is running on a Browser w/ access do Document interface.');
  }

  var s = document.createElement('script');
  s.async = false;
  s.text = "(function(window, document, dataLayerName, id) {\nwindow[dataLayerName]=window[dataLayerName]||[],window[dataLayerName].push({start:(new Date).getTime(),event:\"stg.start\"});var scripts=document.getElementsByTagName('script')[0],tags=document.createElement('script');\nfunction stgCreateCookie(a,b,c){var d=\"\";if(c){var e=new Date;e.setTime(e.getTime()+24*c*60*60*1e3),d=\"; expires=\"+e.toUTCString()}document.cookie=a+\"=\"+b+d+\"; path=/\"}\nvar isStgDebug=(window.location.href.match(\"stg_debug\")||document.cookie.match(\"stg_debug\"))&&!window.location.href.match(\"stg_disable_debug\");stgCreateCookie(\"stg_debug\",isStgDebug?1:\"\",isStgDebug?14:-1);\nvar qP=[];dataLayerName!==\"dataLayer\"&&qP.push(\"data_layer_name=\"+dataLayerName),isStgDebug&&qP.push(\"stg_debug\");var qPString=qP.length>0?(\"?\"+qP.join(\"&\")):\"\";\ntags.async=!0,tags.src=\"" + containerUrl + "/containers/\"+id+\".js\"+qPString,scripts.parentNode.insertBefore(tags,scripts);\n!function(a,n,i){a[n]=a[n]||{};for(var c=0;c<i.length;c++)!function(i){a[n][i]=a[n][i]||{},a[n][i].api=a[n][i].api||function(){var a=[].slice.call(arguments,0);\"string\"==typeof a[0]&&window[dataLayerName].push({event:n+\".\"+i+\":\"+a[0],parameters:[].slice.call(arguments,1)})}}(i[c])}(window,\"ppms\",[\"tm\",\"cm\"]);\n})(window, document, 'dataLayer', '" + containerId + "')";
  var head = document.getElementsByTagName('body')[0];
  head.appendChild(s);
}

var index = {
  init: init
};
var TRACK_EVENT;

(function (TRACK_EVENT) {
  TRACK_EVENT["PAGE_VIEW"] = "trackPageView";
  TRACK_EVENT["CUSTOM_EVENT"] = "trackEvent";
  TRACK_EVENT["GOAL"] = "trackGoal";
  TRACK_EVENT["SEARCH"] = "trackSiteSearch";
  TRACK_EVENT["ADD_ECOMMERCE_ITEM"] = "addEcommerceItem";
  TRACK_EVENT["REMOVE_ECOMMERCE_ITEM"] = "removeEcommerceItem";
  TRACK_EVENT["CLEAR_ECOMMERCE_CART"] = "clearEcommerceCart";
  TRACK_EVENT["SET_ECOMMERCE_VIEW"] = "setEcommerceView";
  TRACK_EVENT["UPDATE_ECOMMERCE_CART"] = "trackEcommerceCartUpdate";
  TRACK_EVENT["ORDER_ECOMMERCE"] = "trackEcommerceOrder";
  TRACK_EVENT["SET_CUSTOM_VARIABLE"] = "setCustomVariable";
  TRACK_EVENT["DELETE_CUSTOM_VARIABLE"] = "deleteCustomVariable";
  TRACK_EVENT["STORE_CUSTOM_VARIABLES_IN_COOKIE"] = "storeCustomVariablesInCookie";
  TRACK_EVENT["SET_CUSTOM_DIMENSION_VALUE"] = "setCustomDimensionValue";
  TRACK_EVENT["DELETE_CUSTOM_DIMENSION"] = "deleteCustomDimension";
  TRACK_EVENT["SET_CUSTOM_DIMENSION"] = "setCustomDimension";
  TRACK_EVENT["ALL_CONTENT_IMPRESSIONS"] = "trackAllContentImpressions";
  TRACK_EVENT["VISIBLE_CONTENT_IMPRESSIONS"] = "trackVisibleContentImpressions";
  TRACK_EVENT["CONTENT_IMPRESSIONS_WITH_NODE"] = "trackContentImpressionsWithinNode";
  TRACK_EVENT["CONTENT_IMPRESSION"] = "trackContentImpression";
  TRACK_EVENT["LOG_ALL_CONTENT_BLOCKS_ON_PAGE"] = "logAllContentBlocksOnPage";
  TRACK_EVENT["CONTENT_INTERACTION_NODE"] = "trackContentInteractionNode";
  TRACK_EVENT["CONTENT_INTERACTION"] = "trackContentInteraction";
  TRACK_EVENT["LINK"] = "trackLink";
  TRACK_EVENT["ENABLE_LINK_TRACKING"] = "enableLinkTracking";
  TRACK_EVENT["SET_IGNORE_CLASSES"] = "setIgnoreClasses";
  TRACK_EVENT["SET_LINK_CLASSES"] = "setLinkClasses";
  TRACK_EVENT["SET_DOWNLOAD_CLASSES"] = "setDownloadClasses";
  TRACK_EVENT["SET_DOWNLOAD_EXTENSIONS"] = "setDownloadExtensions";
  TRACK_EVENT["ADD_DOWNLOAD_EXTENSIONS"] = "addDownloadExtensions";
  TRACK_EVENT["REMOVE_DOWNLOAD_EXTENSIONS"] = "removeDownloadExtensions";
  TRACK_EVENT["SET_LINK_TRACKING_TIMER"] = "setLinkTrackingTimer";
  TRACK_EVENT["SET_USER_ID"] = "setUserId";
  TRACK_EVENT["RESET_USER_ID"] = "resetUserId";
  TRACK_EVENT["SET_USER_IS_ANONYMOUS"] = "setUserIsAnonymous";
  TRACK_EVENT["DEANONYMIZE_USER"] = "deanonymizeUser";
  TRACK_EVENT["SET_SESSION_ID_STRICT_PRIVACY_MODE"] = "setSessionIdStrictPrivacyMode";
  TRACK_EVENT["DISABLE_COOKIES"] = "disableCookies";
  TRACK_EVENT["ENABLE_COOKIES"] = "enableCookies";
  TRACK_EVENT["DELETE_COOKIES"] = "deleteCookies";
  TRACK_EVENT["SET_COOKIE_NAME_PREFIX"] = "setCookieNamePrefix";
  TRACK_EVENT["SET_COOKIE_DOMAIN"] = "setCookieDomain";
  TRACK_EVENT["SET_COOKIE_PATH"] = "setCookiePath";
  TRACK_EVENT["SET_SECURE_COOKIE"] = "setSecureCookie";
  TRACK_EVENT["SET_VISITOR_COOKIE_TIMEOUT"] = "setVisitorCookieTimeout";
  TRACK_EVENT["SET_SESSION_COOKIE_TIMEOUT"] = "setSessionCookieTimeout";
  TRACK_EVENT["SET_VISITOR_ID_COOKIE"] = "setVisitorIdCookie";
  TRACK_EVENT["SET_DOCUMENT_TITLE"] = "setDocumentTitle";
  TRACK_EVENT["SET_DOMAINS"] = "setDomains";
  TRACK_EVENT["SET_CUSTOM_URL"] = "setCustomUrl";
  TRACK_EVENT["SET_REFERRER_URL"] = "setReferrerUrl";
  TRACK_EVENT["SET_API_URL"] = "setApiUrl";
  TRACK_EVENT["GET_PIWIK_URL"] = "getPiwikUrl";
  TRACK_EVENT["GET_CURRENT_URL"] = "getCurrentUrl";
  TRACK_EVENT["DISCARD_HASH_TAG"] = "discardHashTag";
  TRACK_EVENT["SET_GENERATION_TIME_MS"] = "setGenerationTimeMs";
  TRACK_EVENT["APPEND_TO_TRACKING_URL"] = "appendToTrackingUrl";
  TRACK_EVENT["SET_DO_NOT_TRACK"] = "setDoNotTrack";
  TRACK_EVENT["KILL_FRAME"] = "killFrame";
  TRACK_EVENT["REDIRECT_FILE"] = "redirectFile";
  TRACK_EVENT["SET_CAMPAIGN_NAME_KEY"] = "setCampaignNameKey";
  TRACK_EVENT["SET_CAMPAIGN_KEYWORD_KEY"] = "setCampaignKeywordKey";
  TRACK_EVENT["PING"] = "ping";
  TRACK_EVENT["ADD_LISTENER"] = "addListener";
  TRACK_EVENT["SET_REQUEST_METHOD"] = "setRequestMethod";
  TRACK_EVENT["SET_CUSTOM_REQUEST_PROCESSING"] = "setCustomRequestProcessing";
  TRACK_EVENT["SET_REQUEST_CONTENT_TYPE"] = "setRequestContentType";
  TRACK_EVENT["ENABLE_JS_ERROR_TRACKING"] = "enableJSErrorTracking";
  TRACK_EVENT["ERROR"] = "trackError";
  TRACK_EVENT["SET_TRACKING_SOURCE"] = "setTrackingSource";
})(TRACK_EVENT || (TRACK_EVENT = {}));

function push(collection) {
  if (!window._paq) {
    window._paq = [];
  }

  window._paq.push(["setCustomUrl", window.location.pathname]);

  window._paq.push(["setDocumentTitle", document.title]);

  console.log('Push', collection);
  return window._paq.push(collection);
}

var PaqService = {
  push: push
};

function trackPageView(customPageTitle) {
  PaqService.push([TRACK_EVENT.PAGE_VIEW].concat(customPageTitle ? [customPageTitle] : []));
}

var pageViews_service = {
  __proto__: null,
  trackPageView: trackPageView
};

function trackEvent(category, action, name, value) {
  var eventArguments = [category, action].concat(name ? [name] : [], name ? [value] : []);
  PaqService.push([TRACK_EVENT.CUSTOM_EVENT].concat(eventArguments));
}

var customEvents_service = {
  __proto__: null,
  trackEvent: trackEvent
};

function trackAllContentImpressions() {
  PaqService.push([TRACK_EVENT.ALL_CONTENT_IMPRESSIONS]);
}

function trackVisibleContentImpressions(checkOnScroll, watchIterval) {
  PaqService.push([TRACK_EVENT.VISIBLE_CONTENT_IMPRESSIONS, checkOnScroll, watchIterval]);
}

function trackContentImpressionsWithinNode(domNode) {
  PaqService.push([TRACK_EVENT.CONTENT_IMPRESSIONS_WITH_NODE, domNode]);
}

function trackContentImpression(contentName, contentPiece, contentTarget) {
  PaqService.push([TRACK_EVENT.CONTENT_IMPRESSION, contentName, contentPiece, contentTarget]);
}

function logAllContentBlocksOnPage() {
  PaqService.push([TRACK_EVENT.LOG_ALL_CONTENT_BLOCKS_ON_PAGE]);
}

function trackContentInteractionNode(domNode, contentInteraction) {
  PaqService.push([TRACK_EVENT.CONTENT_INTERACTION_NODE, domNode, contentInteraction]);
}

function trackContentInteraction(contentInteraction, contentName, contentPiece, contentTarget) {
  PaqService.push([TRACK_EVENT.CONTENT_INTERACTION, contentInteraction, contentName, contentPiece, contentTarget]);
}

var contentTracking_service = {
  __proto__: null,
  trackAllContentImpressions: trackAllContentImpressions,
  trackVisibleContentImpressions: trackVisibleContentImpressions,
  trackContentImpressionsWithinNode: trackContentImpressionsWithinNode,
  trackContentImpression: trackContentImpression,
  logAllContentBlocksOnPage: logAllContentBlocksOnPage,
  trackContentInteractionNode: trackContentInteractionNode,
  trackContentInteraction: trackContentInteraction
};

function disableCookies() {
  PaqService.push([TRACK_EVENT.DISABLE_COOKIES]);
}

function enableCookies() {
  PaqService.push([TRACK_EVENT.ENABLE_COOKIES]);
}

function deleteCookies() {
  PaqService.push([TRACK_EVENT.DELETE_COOKIES]);
}

function hasCookies() {
  return new Promise(function (resolve, reject) {
    try {
      PaqService.push([function () {
        resolve(this.hasCookies());
      }]);
    } catch (e) {
      if (e instanceof ReferenceError) {
        reject(e);
      }
    }
  });
}

function setCookieNamePrefix(prefix) {
  PaqService.push([TRACK_EVENT.SET_COOKIE_NAME_PREFIX, prefix]);
}

function setCookieDomain(domain) {
  PaqService.push([TRACK_EVENT.SET_COOKIE_DOMAIN, domain]);
}

function setCookiePath(path) {
  PaqService.push([TRACK_EVENT.SET_COOKIE_PATH, path]);
}

function setSecureCookie(secure) {
  PaqService.push([TRACK_EVENT.SET_SECURE_COOKIE, secure]);
}

function setVisitorCookieTimeout(seconds) {
  PaqService.push([TRACK_EVENT.SET_VISITOR_COOKIE_TIMEOUT, seconds]);
}

function setSessionCookieTimeout(seconds) {
  PaqService.push([TRACK_EVENT.SET_SESSION_COOKIE_TIMEOUT, seconds]);
}

function setVisitorIdCookie() {
  PaqService.push([TRACK_EVENT.SET_VISITOR_ID_COOKIE]);
}

var cookieManagement_service = {
  __proto__: null,
  disableCookies: disableCookies,
  enableCookies: enableCookies,
  deleteCookies: deleteCookies,
  hasCookies: hasCookies,
  setCookieNamePrefix: setCookieNamePrefix,
  setCookieDomain: setCookieDomain,
  setCookiePath: setCookiePath,
  setSecureCookie: setSecureCookie,
  setVisitorCookieTimeout: setVisitorCookieTimeout,
  setSessionCookieTimeout: setSessionCookieTimeout,
  setVisitorIdCookie: setVisitorIdCookie
};

function setCustomDimensionValue(customDimensionId, customDimensionValue) {
  PaqService.push([TRACK_EVENT.SET_CUSTOM_DIMENSION_VALUE, customDimensionId, customDimensionValue]);
}

function deleteCustomDimension(customDimensionId) {
  PaqService.push([TRACK_EVENT.DELETE_CUSTOM_DIMENSION, customDimensionId]);
}

function getCustomDimensionValue(customDimensionId) {
  return new Promise(function (resolve, reject) {
    try {
      PaqService.push([function () {
        resolve(this.getCustomDimensionValue(customDimensionId));
      }]);
    } catch (e) {
      if (e instanceof ReferenceError) {
        reject(e);
      }
    }
  });
}

var customDimensions_service = {
  __proto__: null,
  setCustomDimensionValue: setCustomDimensionValue,
  deleteCustomDimension: deleteCustomDimension,
  getCustomDimensionValue: getCustomDimensionValue
};

function trackLink(url, linkType, customData, callback) {
  PaqService.push([TRACK_EVENT.LINK, url, linkType, customData, callback]);
}

function enableLinkTracking(enable) {
  PaqService.push([TRACK_EVENT.ENABLE_LINK_TRACKING, enable]);
}

function setLinkClasses(classes) {
  PaqService.push([TRACK_EVENT.SET_LINK_CLASSES, classes]);
}

function setDownloadClasses(classes) {
  PaqService.push([TRACK_EVENT.SET_DOWNLOAD_CLASSES, classes]);
}

function setDownloadExtensions(extensions) {
  PaqService.push([TRACK_EVENT.SET_DOWNLOAD_EXTENSIONS, extensions]);
}

function addDownloadExtensions(extensions) {
  PaqService.push([TRACK_EVENT.ADD_DOWNLOAD_EXTENSIONS, extensions]);
}

function removeDownloadExtensions(extensions) {
  PaqService.push([TRACK_EVENT.REMOVE_DOWNLOAD_EXTENSIONS, extensions]);
}

function setLinkTrackingTimer(time) {
  PaqService.push([TRACK_EVENT.SET_LINK_TRACKING_TIMER, time]);
}

function getLinkTrackingTimer() {
  return new Promise(function (resolve, reject) {
    try {
      PaqService.push([function () {
        resolve(this.getLinkTrackingTimer());
      }]);
    } catch (e) {
      if (e instanceof ReferenceError) {
        reject(e);
      }
    }
  });
}

function setIgnoreClasses(classes) {
  PaqService.push([TRACK_EVENT.SET_IGNORE_CLASSES, classes]);
}

var downloadAndOutlink_service = {
  __proto__: null,
  trackLink: trackLink,
  enableLinkTracking: enableLinkTracking,
  setLinkClasses: setLinkClasses,
  setDownloadClasses: setDownloadClasses,
  setDownloadExtensions: setDownloadExtensions,
  addDownloadExtensions: addDownloadExtensions,
  removeDownloadExtensions: removeDownloadExtensions,
  setLinkTrackingTimer: setLinkTrackingTimer,
  getLinkTrackingTimer: getLinkTrackingTimer,
  setIgnoreClasses: setIgnoreClasses
};

function addEcommerceItem(productSKU, productName, productCategory, productPrice, productQuantity) {
  PaqService.push([TRACK_EVENT.ADD_ECOMMERCE_ITEM, productSKU, productName, productCategory, productPrice, productQuantity]);
}

function removeEcommerceItem(productSKU) {
  PaqService.push([TRACK_EVENT.REMOVE_ECOMMERCE_ITEM, productSKU]);
}

function clearEcommerceCart() {
  PaqService.push([TRACK_EVENT.CLEAR_ECOMMERCE_CART]);
}

function getEcommerceItems() {
  return new Promise(function (resolve, reject) {
    try {
      PaqService.push([function () {
        resolve(this.getEcommerceItems());
      }]);
    } catch (e) {
      if (e instanceof ReferenceError) {
        reject(e);
      }
    }
  });
}

function trackEcommerceOrder(orderId, orderGrandTotal, orderSubTotal, orderTax, orderShipping, orderDiscount) {
  PaqService.push([TRACK_EVENT.ORDER_ECOMMERCE, orderId, orderGrandTotal, orderSubTotal, orderTax, orderShipping, orderDiscount]);
}

function trackEcommerceCartUpdate(cartAmount) {
  PaqService.push([TRACK_EVENT.UPDATE_ECOMMERCE_CART, cartAmount]);
}

function setEcommerceView(productSKU, productName, productCategory, productPrice) {
  PaqService.push([TRACK_EVENT.SET_ECOMMERCE_VIEW, productSKU, productName, productCategory, productPrice]);
}

var eCommerce_service = {
  __proto__: null,
  addEcommerceItem: addEcommerceItem,
  removeEcommerceItem: removeEcommerceItem,
  clearEcommerceCart: clearEcommerceCart,
  getEcommerceItems: getEcommerceItems,
  trackEcommerceOrder: trackEcommerceOrder,
  trackEcommerceCartUpdate: trackEcommerceCartUpdate,
  setEcommerceView: setEcommerceView
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function trackGoal(goalId, conversionValue, dimensions) {
  PaqService.push([TRACK_EVENT.GOAL, goalId, conversionValue].concat(dimensions ? [_extends({}, dimensions)] : []));
}

var goalConversions_service = {
  __proto__: null,
  trackGoal: trackGoal
};

function trackSiteSearch(keyword, category, searchCount, dimensions) {
  PaqService.push([TRACK_EVENT.SEARCH, keyword, category, searchCount, dimensions]);
}

var siteSearch_service = {
  __proto__: null,
  trackSiteSearch: trackSiteSearch
};

function getUserId() {
  return new Promise(function (resolve, reject) {
    try {
      PaqService.push([function () {
        resolve(this.getUserId());
      }]);
    } catch (e) {
      if (e instanceof ReferenceError) {
        reject(e);
      }
    }
  });
}

function setUserId(userId) {
  PaqService.push([TRACK_EVENT.SET_USER_ID, userId]);
}

function resetUserId() {
  PaqService.push([TRACK_EVENT.RESET_USER_ID]);
}

function getVisitorId() {
  return new Promise(function (resolve, reject) {
    try {
      PaqService.push([function () {
        resolve(this.getVisitorId());
      }]);
    } catch (e) {
      if (e instanceof ReferenceError) {
        reject(e);
      }
    }
  });
}

function getVisitorInfo() {
  return new Promise(function (resolve, reject) {
    try {
      PaqService.push([function () {
        resolve(this.getVisitorInfo());
      }]);
    } catch (e) {
      if (e instanceof ReferenceError) {
        reject(e);
      }
    }
  });
}

var userManagement_service = {
  __proto__: null,
  getUserId: getUserId,
  setUserId: setUserId,
  resetUserId: resetUserId,
  getVisitorId: getVisitorId,
  getVisitorInfo: getVisitorInfo
};
var index$1 = {
  initialize: index.init
};
export default index$1;
export { contentTracking_service as ContentTracking, cookieManagement_service as CookieManagement, customDimensions_service as CustomDimensions, customEvents_service as CustomEvent, downloadAndOutlink_service as DownloadAndOutlink, goalConversions_service as GoalConversions, pageViews_service as PageViews, siteSearch_service as SiteSearch, userManagement_service as UserManagement, eCommerce_service as eCommerce };